import { CellContext } from "@tanstack/react-table";
import { EntityIconList } from "@components/general/EntityIconList/EntityIconList";
import { Entity } from "@common/types/entity";
import { ClientDetailsRow } from "../clientViewConfig";

export const EntitiesCell = ({
    getValue,
}: CellContext<ClientDetailsRow, Entity[]>) => {
    if (getValue().length === 0) {
        return null;
    }

    return (
        <EntityIconList
            entities={getValue()}
            maxEntitiesToDisplay={Number.MAX_VALUE}
            showLabel={false}
        />
    );
};
